import { useNavigate } from "react-router-dom";
import { useToast } from "../../../context/ToastContext";
import useApiService from "../../../hooks/useApiService";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { PTOItem, PTORecord } from "../../../models/PtoRecord";
import { useEffect } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { PtoSiteList, PtoTopics } from "../../../components/pto/site";
import { Card } from "primereact/card";

function PtoList(props: RouteComponentProps) {
  const toast = useToast();
  const navigate = useNavigate();
  const { data, loading } = useApiService<PTORecord[]>({
    method: "GET",
    url: "pto-list",
    apiName: "core",
    onError: () => {
      toast("error", "Could not load PTO List, please try again later");
    },
  });

  const { data: ptoTopics, loading: topicsLoading } = useApiService<PTOItem[]>({
    method: "GET",
    url: "pto-topic",
    apiName: "core",
    onError: () => {
      toast("error", "Could not load PTO Topics, please try again later");
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading || topicsLoading);

    if (!props.session.site_id) {
      toast("error", "No site id found in session", 3000);
      props.setGlobalLoader(false);
      navigate("/", {
        replace: true,
      });
    }
  }, [loading, topicsLoading]);

  return (
    <div>
      <h1>PTO Management</h1>

      <TabView>
        <TabPanel header={"PTO Topics"}>
          {ptoTopics && ptoTopics?.length > 0 ? (
            <PtoTopics ptoTopics={ptoTopics} />
          ) : (
            <Card>
              <h2 style={{ textAlign: "center" }}>No PTO found for today</h2>
            </Card>
          )}
        </TabPanel>
        <TabPanel header={"PTO List"}>
          <PtoSiteList ptoList={data} session={props.session} />
        </TabPanel>
      </TabView>
    </div>
  );
}

export default PtoList;
